import { View, ViewModel } from "binder";

export interface IPaymentInfoProvider{
    getBasePaymentInfoDto():{
        processId:string,
        attachments:{
            id:string,
            name:string,
            content:string
        }[]
    };

}

export interface IGateway {
    get title():string;
    save(dataProvider : IPaymentInfoProvider):Promise<any>;
    initialLoad(paymentInfo?:PaymentInfo):void;
    validate():string[];
}


export class PaymentInfo extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set AccountNumber(v: string) { this._AccountNumber = v; } public get AccountNumber(): string { return this._AccountNumber;} private _AccountNumber: string;
    public set Iban(v: string) { this._Iban = v; } public get Iban(): string { return this._Iban;} private _Iban: string;
    public set CreditCardNumber(v: string) { this._CreditCardNumber = v; } public get CreditCardNumber(): string { return this._CreditCardNumber;} private _CreditCardNumber: string;
}
